import { render, staticRenderFns } from "./ZhongDian.vue?vue&type=template&id=b693240e&scoped=true&"
import script from "./ZhongDian.vue?vue&type=script&lang=js&"
export * from "./ZhongDian.vue?vue&type=script&lang=js&"
import style0 from "./ZhongDian.vue?vue&type=style&index=0&id=b693240e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b693240e",
  null
  
)

export default component.exports